import {
  DateString,
  Shift,
  TimeString,
  getDuration,
  makeDateTime,
} from '@nextforce/api'
import moment from 'moment-timezone'

export function getStartDateTime(
  date: DateString,
  startTime: TimeString,
  tz?: string
) {
  return makeDateTime(date, startTime, tz)
}

export function getEndDateTime(
  date: DateString,
  startTime: TimeString,
  endTime: TimeString,
  tz?: string
) {
  const startDateTime = makeDateTime(date, startTime, tz)
  let endDateTime = makeDateTime(date, endTime, tz)

  if (getDuration(startDateTime, endDateTime) < 0) {
    endDateTime = moment(endDateTime).add(1, 'day').toDate()
  }

  return endDateTime
}

export function getShiftStartDateTime(shift: Shift) {
  return getStartDateTime(shift.date, shift.startTime, shift.tz)
}

export function getShiftEndDateTime(shift: Shift) {
  return getEndDateTime(shift.date, shift.startTime, shift.endTime, shift.tz)
}
